// extracted by mini-css-extract-plugin
module.exports = {"assignees":"Assignees_assignees__Im6sX","assign":"Assignees_assign__O9jXm"};